const persistedColors = {
  primary: {
    main: '#B2251A',
    dark: '#FF0000',
    light: '#B2251A',
    light1: '#C75E55',
    light2: '#FFBFBF',
    light3: '#FBF5F4',
    light4: '#F0D3D1',
  },
  tertiary: {
    dark: '#13CF78',
    main: '#0FC789',
    light: '#C3F1E1',
  },
  persisted: {
    primary: '#000000',
    secondary: '#FFFFFF',
    secondary1: '#D3D3D3',
  },
};

export const lightTheme = {
  palette: {
    secondary: {
      dark: '#171717CC',
      dark1: '#333333',
      dark2: '#373A47',
      main: '#808080',
      main1: '#999999',
      main2: '#CACACA',
      main3: '#B8B7AD',
      light: '#BFBFBF',
      light1: '#C9C7C7',
      light2: '#E5E5E5',
      light3: '#F2F2F2',
      light4: '#F1F1F1',
      light5: '#CCCCCC',
      light6: '#EBEBEB',
      light7: '#FBF5F4',
    },
    brand: {
      primary: '#000000',
      secondary: '#FFFFFF',
      secondary1: '#FFFFFF',
    },

    filter: 0,
    avatarBg: [255, 255, 255, 1],
    ...persistedColors,
  },
};
export const darkTheme = {
  palette: {
    secondary: {
      dark: '#e8e8e8',
      dark1: '#cccccc',
      dark2: '#c8c5b8',
      main: '#7f7f7f',
      main1: '#666666',
      main2: '#353535',
      main3: '#474852',
      light: '#404040',
      light1: '#363838',
      light2: '#1a1a1a',
      light3: '#252525',
      light4: '#0e0e0e',
      light5: '#333333',
      light6: '#141414',
      light7: '#1a1a1a',
    },
    brand: {
      primary: '#FFFFFF',
      secondary: '#121212',
      secondary1: '#252525',
    },
    filter: 1,
    avatarBg: [18, 18, 18, 1],
    ...persistedColors,
  },
};
